import(/* webpackMode: "eager", webpackExports: ["AttributionProvider"] */ "/vercel/path0/app/components/analytics/AttributionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalePreference"] */ "/vercel/path0/app/components/i18n/LocalePreference.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChromeSite","WidgetsFlottants"] */ "/vercel/path0/app/components/layout/ChromeSite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuiviNavigation"] */ "/vercel/path0/app/components/navigation/suivi-navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\"],\"display\":\"swap\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"]}],\"variableName\":\"jakarta\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/_index.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/tw-animate-css.css");
